import React, { ForwardedRef, useRef } from 'react'
import { Col, Container, Row } from "reactstrap"
import Navbar from "../../components/Navbar"
//@ts-ignore
import photo from "../../assets/jobPic.webp"
import "./styles.css"
import CustomButton from '../../components/CustomButton'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NavBar from '../../components/Navbar'

export default function AboutUs() {
    const navigate = useNavigate()

    const { t } = useTranslation()

    return (
        <div className='home'>
            <Container >
                <NavBar />
                <Row className='row-area'>
                    <div className='about-us'>
                        <h2 style={{ color: "#fff", fontFamily: "cursive" }}>{t('aboutUs')}</h2>
                        <br />
                        <div className='first-col'>
                            <h3>{t('aboutUs1')}</h3>
                        </div>
                        <div className='first-col'>
                            <h3>{t('aboutUs2')}</h3>
                        </div>
                        <div className='first-col'>
                            <h3>{t('aboutUs3')}</h3>
                        </div>
                        <div className='first-col'>
                            <h3>{t('aboutUs4')}</h3>
                        </div>
                        <hr style={{ color: "#ddd" }} />
                        <div className='first-col'>
                            <h3>{t('aboutUs5')}</h3>
                        </div>
                        <div className='first-col'>
                            <h3>{t('aboutUs6')}</h3>
                        </div>
                        <div className='first-col'>
                            <h3>{t('aboutUs7')}</h3>
                        </div>
                        {/* <div className='first-col'>
                            <h3>{t('aboutUs8')}</h3>
                        </div> */}
                    </div>
                    <CustomButton className='mt-3 ms-2' label={t('startButton')} onClick={() => navigate("/jobs")} />

                </Row>
            </Container>
        </div>
    )
}
